import {
  Table as BaseTable,
  TableBody,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
} from "./Table.js";

export type {
  TableBodyProps,
  TableDataProps,
  TableHeaderProps,
  TableHeadProps,
  TableProps,
  TableRowProps,
} from "./Table.js";

export const Table = Object.assign(BaseTable, {
  Body: TableBody,
  D: TableData,
  H: TableHeader,
  Head: TableHead,
  R: TableRow,
});
